import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _callSuper from "@babel/runtime/helpers/callSuper";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import { findDOMNode } from 'react-dom';
import { getComponentDisplayName } from '../util/getComponentDisplayName';
var defaultOptions = {
  removeObserverOnInView: true,
  listenForScrollOutEvent: false
};
function shouldSetMinHeight(element) {
  var style = getComputedStyle(element);
  return !style.minHeight || style.minHeight === 'none' || style.minHeight === '0px';
}
export function hasScrolledIntoView(Component) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultOptions;
  var displayName = getComponentDisplayName(Component);
  var intersectionObserverCallback = function intersectionObserverCallback(changes) {
    changes.forEach(function (entry) {
      var setIsVisible = elementCallbacks.get(entry.target);
      if (!setIsVisible) {
        return;
      }
      if (options.listenForScrollOutEvent) {
        setIsVisible(entry.intersectionRatio > 0, entry.isIntersecting);
        return;
      } else if (entry.intersectionRatio > 0) {
        setIsVisible(true, entry.isIntersecting);
      }
    });
  };
  if (options.listenForScrollOutEvent && options.removeObserverOnInView) {
    // We can't both listen for scroll out and not report it anywhere. Well, we can. But that's silly
    // because it won't do anything.
    console.warn('Both listenForScrollOutEvent and removeObserverOnInView were set - this is probably not going to work like you think it will.');
  }
  function createObserver() {
    var newObserver = new IntersectionObserver(intersectionObserverCallback, options.observerInitOpts);
    newObserver.POLL_INTERVAL = 1000;
    return newObserver;
  }
  var observer;
  var elementCallbacks = new Map();
  function observeElement(element, handler) {
    if (!observer) {
      observer = createObserver();
    }
    observer.observe(element);
    if (!elementCallbacks.has(element)) {
      elementCallbacks.set(element, handler);
    }
  }
  function unobserveElement(element) {
    if (!elementCallbacks.has(element)) {
      return;
    }
    if (elementCallbacks.size > 0) {
      observer.unobserve(element);
    } else {
      observer.disconnect();
    }
    elementCallbacks["delete"](element);
  }
  var HasScrolledIntoView = /*#__PURE__*/function (_React$Component) {
    function HasScrolledIntoView() {
      var _this;
      _classCallCheck(this, HasScrolledIntoView);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _callSuper(this, HasScrolledIntoView, [].concat(args));
      _defineProperty(_this, "domNode", void 0);
      _defineProperty(_this, "state", {
        hasScrolledIntoView: false,
        initSetup: options,
        isIntersecting: false
      });
      _defineProperty(_this, "handleObserver", function (didScrollIntoView, isIntersecting) {
        if (options.removeObserverOnInView && _this.domNode) {
          unobserveElement(_this.domNode);
        }
        _this.setState({
          hasScrolledIntoView: didScrollIntoView,
          isIntersecting: isIntersecting
        });
      });
      return _this;
    }
    _inherits(HasScrolledIntoView, _React$Component);
    return _createClass(HasScrolledIntoView, [{
      key: "render",
      value: function render() {
        return /*#__PURE__*/React.createElement(Component, _extends({}, this.props, this.state));
      }
    }, {
      key: "componentDidMount",
      value: function componentDidMount() {
        this.domNode = findDOMNode(this);
        if (this.domNode.clientHeight === 0) {
          try {
            if (shouldSetMinHeight(this.domNode)) {
              this.domNode.style.minHeight = '1px';
            }
          } catch (_e) {}
        }
        observeElement(this.domNode, this.handleObserver);
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        if (this.domNode) {
          unobserveElement(this.domNode);
        }
      }
    }]);
  }(React.Component);
  _defineProperty(HasScrolledIntoView, "displayName", displayName);
  return HasScrolledIntoView;
}